import { Loader2 } from "lucide-react";
import React from "react";

export function SocialProfileSyncingState() {
  return (
    <div className="flex flex-col grow justify-center items-center text-center px-4 py-6 bg-slate-50/50 rounded-2xl border border-slate-100 border-dashed">
      <Loader2 className="animate-spin text-amber-400 mb-3" size={28} />
      <span className="text-sm font-semibold text-slate-700">Syncing Profile...</span>
      <span className="text-sm text-slate-500 mt-1 text-center">
        Fetching your latest updates. This might take a few seconds, but you're free to leave this page and start
        posting.
      </span>
    </div>
  );
}
